import i from "./ghl-ui.es688.js";
import e from "./ghl-ui.es984.js";
import f from "./ghl-ui.es1174.js";
import n from "./ghl-ui.es1175.js";
import a from "./ghl-ui.es1176.js";
import p from "./ghl-ui.es1173.js";
import s from "./ghl-ui.es1177.js";
var u = 1, A = 2;
function y(r, o) {
  return n(r) && a(o) ? p(s(r), o) : function(m) {
    var t = e(m, r);
    return t === void 0 && t === o ? f(m, r) : i(o, t, u | A);
  };
}
export {
  y as default
};
